import React, { useEffect, useState } from "react";
import "./quiz.css";
import Question from "../question";
import { Button } from "../button/button";
import { useSubmitQuiz } from "../../hooks/useSubmitQuiz";
import { toast } from "react-toastify";
import { localStoreName } from "../../utils/constants";
import QuizCompleteModal from "../quizCompleteModal";

const Quiz = () => {
  const [quiz, setQuiz] = useState(null);
  const [answers, setAnswers] = useState([]);
  const { loading, submitQuiz } = useSubmitQuiz();
  const [quizSubmitted, setQuizSubmitted] = useState(false);

  useEffect(() => {
    const quizFromStorage = JSON.parse(
      localStorage.getItem(localStoreName)
    )?.user_quiz;

    setQuiz(quizFromStorage);
  }, []);

  const addAnswer = (submittedAnswer) => {
    const answerExistsId = answers.findIndex(
      (answer) => answer.question_id == submittedAnswer.question_id
    );
    if (answerExistsId < 0) {
      // answer not ticked yet
      setAnswers([...answers, submittedAnswer]);
    } else {
      // answer already ticked
      const newAnswers = answers.map((answer) =>
        answer?.question_id == submittedAnswer.question_id
          ? submittedAnswer
          : answer
      );
      setAnswers(newAnswers);
    }
  };

  const submit = async () => {
    const { data, error } = await submitQuiz(answers);
    if (data) {
      setQuiz(data);
      toast.success("Quiz submitted sucessfully.");
      setQuizSubmitted(true);
    } else {
      toast.error(error);
    }
  };

  return (
    <div className="quizContainer">
      {quizSubmitted ? <QuizCompleteModal /> : null}
      <div className="questionsContainer">
        {quiz?.questions?.map((q, index) => (
          <Question
            key={q._id}
            question={q}
            index={index}
            handleSubmit={addAnswer}
          />
        ))}
      </div>
      {quiz?.questions.length > 0 ? (
        <div className="buttonContainer">
          <Button
            buttonName={loading ? "" : "Submit"}
            main="fill"
            type="submit"
            onClick={submit}
            loading={loading}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Quiz;
